import React from "react";
import * as styles from "./section-paragraph.module.scss";
import { RichText } from "../RichText/RichText";

const SectionParagraph = ({ data }) => {
  const { description1, description2 } = data;

  return ( 
    <>
      <div className= {` bg-white container ${styles.mainSection}`} >
        <div className={`c-padding ${styles.col1} ${styles.styleTick}`}>
          {description1 && <RichText content={description1} />}
        </div>
        { description2 &&
        <div className={`c-padding ${styles.col2}`}>
          {description2 && <RichText content={description2}  />}
        </div>}
      </div>
    </>
  );
};

export default SectionParagraph;
